export default __webpack_public_path__ + "images/c95b34a47e91c391893fd0a7e888561c-empresa.svg";